const hasKey = (obj, key) => {
  return [key] in obj
}

export default hasKey
